import { AppBar, IconButton, Toolbar } from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import { LogoText } from '@farmshare/ui-components';

interface MobileTopBarProps {
  onOpenDrawer: () => void;
  height: number;
}

export function MobileTopBar({ onOpenDrawer, height }: MobileTopBarProps) {
  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        bgcolor: 'primary.main',
        color: 'text.primary',
        height,
        display: { xs: 'flex', md: 'none' },
        '@media print': { display: 'none' },
      }}
    >
      <Toolbar
        disableGutters
        sx={{
          minHeight: `${height}px !important`,
          height,
          px: 2,
          justifyContent: 'center',
          alignItems: 'center',
          position: 'relative',
        }}
      >
        <IconButton
          onClick={onOpenDrawer}
          sx={{ position: 'absolute', left: 8, color: 'background.default' }}
        >
          <MenuIcon />
        </IconButton>
        <LogoText
          sx={{
            height: 30,
            minWidth: 120,
            maxWidth: 120,
            color: 'background.default',
          }}
        />
      </Toolbar>
    </AppBar>
  );
}
